import styled from 'styled-components';

import { colors, ds } from '@/config/colors';
import type { EnvBadgeKind } from '@/utils/appEnvironment';
import { media } from '@/utils/mediaQueries';

// DEV bursztynowy jak env-banner w mailach (renderEmail), TEST niebieski, LOCALHOST fioletowy, żeby wszystkie
// dało się odróżnić na pierwszy rzut oka. Te same wartości używa hs-admin, zmieniaj w obu miejscach.
const palette = {
  local: { bg: colors.violet[100], fg: colors.violet[800] },
  dev: { bg: colors.warning[100], fg: colors.warning[800] },
  test: { bg: colors.info[100], fg: colors.info[800] },
} as const;

export const EnvPill = styled.span<{ $kind: EnvBadgeKind }>`
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    height: 20px;
    padding: 0 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0.04em;
    white-space: nowrap;
    cursor: default;
    user-select: none;
    background: ${({ $kind }) => palette[$kind].bg};
    color: ${({ $kind }) => palette[$kind].fg};

    .env-short {
        display: none;
    }

    /* Na telefonie „LOCALHOST” wypychał selektor hotelu z paska, stąd krótsza wersja i ciaśniejszy padding. */
    ${media.mobile} {
        padding: 0 6px;
        letter-spacing: 0.02em;

        .env-full {
            display: none;
        }

        .env-short {
            display: inline;
        }
    }

    &:focus-visible {
        outline: 2px solid ${ds.accentInk};
        outline-offset: 3px;
    }
`;
